/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import { Card, CardBody, CardCategory, CardTitle, Container, Icon, Row, Col, Spinner } from 'design-react-kit';
import React, { useState, useEffect } from 'react';
import ApiService from '../../../services/api';
import Pagination from 'pa_kit/pagination';
import env from '../../../env';

const WidgetServices = (props) => {

    const [ widget ] = useState(props.widget);

    const [ servicesList, setServicesList ] = useState();
    const [ currentServices, setCurrentServices ] = useState();
    const [ isLoading, setIsLoading ] = useState(true);

    const [ paginationState, setPaginationState ] = useState({
        currentPage: 1,
        servicesPerPage: widget.data.show_number
    });

    const handlePageChange = (pageNumber) => {
        setPaginationState({ ...paginationState, currentPage: pageNumber });
    };

    let tag_slug;

    let page = props.page || '';

    if(widget.data.tag_slug) {
        tag_slug = widget.data.tag_slug;
    }

    const fetchServicesList = async() => {

        let servicesListData;

        if(env.SPORTELLO_BASE_URL !== '') {
            if(!servicesList) {

                servicesListData = await ApiService.getServicesByTag(tag_slug);              
    
                setServicesList(servicesListData);
                setIsLoading(false);
            } else {
                servicesListData = servicesList;            
            } 
        } else {
            servicesListData = '';
            setServicesList(servicesListData);
            setIsLoading(false);            
        }
                      
        
        const indexOfLastElement = paginationState.currentPage * paginationState.servicesPerPage;
        const indexOfFirstElement = indexOfLastElement - paginationState.servicesPerPage;
        const currentServicesListData = servicesListData.slice(indexOfFirstElement, indexOfLastElement);
        setCurrentServices(currentServicesListData);
   
    }

    useEffect(() => {
        fetchServicesList();
    }, [paginationState]);    

    if(isLoading) return <Container>{page !== 'tag' && <Spinner active />}</Container>
    if(servicesList && (servicesList === '' || servicesList.length === 0)) return page !== 'tag' && <Container>Nessun Risultato</Container>

    return <>
        {page === 'tag' && (servicesList && servicesList.length !== 0) &&
             <Container className="mt-5 pt-5">
                <h2 className="news-by-tags-title mb-4 px-1">Servizi</h2>  
            </Container>
        }
        <h2 className="service-page-title mt-2">{widget.data.label ? widget.data.label : 'Elenco Servizi'}</h2>
        <Container id="service-elements-wrapper" fluid className={widget.data.class + '-service page-service-content'}>
            <Row>
            {currentServices && currentServices.map((service) => {
                return (
                        <Col key={service.slug} xs='12' lg='4' className="mt-2">
                            <Card className='card-img no-after shadow-sm'>  
                                <CardBody className="px-4">
                                    <CardCategory iconName="it-settings"> 
                                        {service.category.name}
                                    </CardCategory>
                                    <CardTitle className="fw-semibold"> <a className="service-title-link" href={'/servizio/' + service.slug + '/'}>{service.name}</a> </CardTitle>
                                    <div className="mt-2 news-description mb-5">
                                        {(service.description).replace(/(<([^>]+)>)/gi, "").substring(0, 100) + '...'}
                                    </div>
                                    <a className="read-more position-relative" href={'/servizio/' + service.slug + '/'}>Vai al servizio <Icon icon="it-arrow-right" /></a>
                                    <div className="mt-5">
                                    {service.tags && service.tags.map((tag) => 
                                        <div key={tag} className={"chip chip-simple chip-primary me-2"}>
                                            <a className="chip-label" href={"/argomenti/" + tag}>{tag}</a>
                                        </div>
                                    )} 
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>                    
                )
            })}
            </Row>
            <Pagination
                elementsPerPage={paginationState.servicesPerPage}
                totalElements={servicesList && servicesList.length}
                currentPage={paginationState.currentPage}
                onPageChange={handlePageChange}
                type="services"
            />  
        </Container>        
    </>;
}

export default WidgetServices;